import {combineReducers} from 'redux';
import link from './link/reducer';
import history from './history/reducer';

export default combineReducers({
  link,
  history,
});
